/**
 * A titled list of on/off rows. Backs both the storeys panel and the
 * categories panel — they are the same widget with different data.
 */
import { clear, el, mount } from "../components/dom";

export interface ToggleItem {
  readonly id: string;
  readonly label: string;
  readonly on: boolean;
}

export interface ToggleList {
  readonly root: HTMLElement;
  render(items: readonly ToggleItem[]): void;
}

export function createToggleList(
  title: string,
  onToggle: (id: string, on: boolean) => void,
): ToggleList {
  const root = el("section", "glass enter flex flex-col gap-1 p-3 min-h-0");
  const header = el("div", "flex items-center justify-between px-1 pb-1");
  mount(header, el("span", "panel-title", title));

  const body = el("div", "panel-body flex flex-col gap-0.5");
  const empty = el("p", "px-1 py-2 text-xs text-[var(--color-ink-300)]", "No model loaded.");

  mount(root, header, body, empty);

  return {
    root,
    render(items) {
      clear(body);
      empty.hidden = items.length > 0;

      for (const item of items) {
        const row = el("button", "row");
        row.type = "button";

        const swatch = el("span", "swatch");
        swatch.dataset["on"] = String(item.on);

        const label = el("span", "truncate", item.label);
        label.title = item.label;

        mount(row, swatch, label);
        row.addEventListener("click", () => {
          const next = swatch.dataset["on"] !== "true";
          swatch.dataset["on"] = String(next);
          onToggle(item.id, next);
        });
        body.appendChild(row);
      }
    },
  };
}
